@if(iframe && iframe.src!=null){
  
<div style="width:100%;position:relative;" [ngStyle]="{'max-width':maxWidth}" >
  <!-- <div [ngStyle]="{'aspect-ratio' : aspectRatio}"> -->  <!-- 'aspect-ratio' IS NOT SUPPORTED in iOS 14 and below... -->   
    <div [ngStyle]="{'padding-bottom' : paddingBottom}">
      <iframe 
      [src]="iframe.src | safe: 'resourceUrl'" 
      [title]="iframe.title" 
      [id]="id" 
      [attr.loading]="useLazy ? 'lazy' : null"     
      class="chart-frame" 
      [attr.alphaSymbol]="alphaSymbol"
      width="100%" 
      height="100%" 
      frameborder="0" 
      scrolling="no" 
      allowfullscreen="true" 
      referrerpolicy="unsafe-url" 
      style="border:none;overflow:hidden; width:100%;min-width:100%;height:100%;min-height:100%;max-height:100%;position:absolute;top:0;left:0;right:0;bottom:0;max-width:800px"></iframe>
  </div>
</div>

}